<template>
  <div>
    <b-card no-body style="padding:5px;margin-bottom:5px !important">
      <b-row>
        <b-col md="3">
          <v-select
            :options="listCampeonatos"
            placeholder="Sel. Camp"
            :clearable="false"
            v-model="campeonatoSeleccionado"
          />
        </b-col>
        <b-col>
          <v-select
            :options="listEquipos"
            @input="changeCategoria"
            placeholder="Seleccione Categoria"
            :clearable="false"
            v-model="equipoSeleccionada"
          />
        </b-col>
      </b-row>
    </b-card>
    <template>
      <b-overlay :show="showLoading" rounded="sm">
        <b-card no-body style="padding:8px;margin-bottom:5px !important"
          ><div v-if="mostra" class="d-flex flex-wrap">
            <h5>Datos:</h5>
            <b-form-checkbox v-model="chekTodos" class="ml-1">
              Todo
            </b-form-checkbox>
            <b-form-checkbox v-model="chekAmarilla" class="ml-1 ">
              Amarillas
            </b-form-checkbox>
            <b-form-checkbox v-model="chekRoja" class="ml-1 ">
              Rojas
            </b-form-checkbox>
            <b-form-checkbox v-model="chekRojaDA" class="ml-1 ">
              Rojas x 2A
            </b-form-checkbox>
            <b-form-checkbox v-model="chekSanciones" class="ml-1 ">
              Suspendido
            </b-form-checkbox>
            <b-form-checkbox v-model="chekGF" class="ml-1 ">
              Goles
            </b-form-checkbox>
            <b-form-checkbox v-model="chekDestacados" class="ml-1 ">
              Destacado
            </b-form-checkbox>
          </div>
          <span
            style="padding:3px;background-color: #cbfda8; color:black;margin-left: 10px; border-radius: 3px;"
            >Actuaciones</span
          >
        </b-card>
        <!-- <b-card no-body style="padding:5px; margin-bottom: 5px;">
          <div class="d-flex flex-wrap">
            <h5>Estados:</h5>
            <b-form-checkbox v-model="chekTodosEstados" class="ml-1">
              Todo
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPG" class="ml-1 ">
              Ganados
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPP" class="ml-1 ">
              Perdidos
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPE" class="ml-1 ">
              Empatados
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPNP" class="ml-1 ">
              No presentado
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPS" class="ml-1 ">
              Sancionados
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPJ" class="ml-1 ">
              Por jugar
            </b-form-checkbox>
            <b-form-checkbox v-model="chekPD" class="ml-1 ">
              Descansa
            </b-form-checkbox>
          </div>
        </b-card> -->
        <div style="width: 100%; height: 100vh; overflow-x: auto;">
          <table>
            <tr>
              <td
                style="background-color: #00bcd4; position: sticky; left: 0; top:0; z-index: 10; "
              >
                <div style="color:white; font-size: 12px; text-align: center;">
                  Etapa / fecha
                </div>
              </td>
              <td
                class="fila"
                style="border-left:3px solid #f3f3f3"
                :style="estilos[item.etapa]"
                v-for="item in mallaAux.malla"
                :key="item.id"
              >
                <div style=" color:white;text-align: center;border-bottom:0.5px solid white">
                  {{ item.etapa }} / {{ item.num_fecha }}
                </div>
                <div style=" background-color: #9b9b9b;color:white;text-align: left; font-size:10px;font-weight: bolder">
                  <span style="margin-left:3px"
                    >{{ item.partido.local }}
                  </span>
                  <div
                    style=" background-color: #9b9b9b; color:white; padding: 3px; font-size:12px;text-align:center;font-weight: bolder"
                  >
                    {{ item.partido.goles_local }} vs {{ item.partido.goles_visita }}</div
                  >
                </div>
                <div style="  background-color: #9b9b9b;color:white;text-align: right; font-size:10px;font-weight: bolder">
                  <!-- <span
                    style="background-color: #5b5a5a; color:white; padding: 3px; font-size:11px"
                    >{{ item.partido.goles_visita }}
                  </span> -->
                  <span style="margin-left:3px ">
                    {{ item.partido.visita }}</span
                  >
                </div>
                <div
                  style="color: dimgray;font-size: 11px; font-weight: bolder;background:white;text-align:center"
                  >{{ item.partido.fecha_aux }}
                </div>
              </td>
            </tr>
            <tr
              style="border-bottom:5px solid #f3f3f3"
              v-for="(item, index) of lisEstadisticas"
              :key="index"
            >
              <!-- Primera columna fija -->
              <td
                style="background-color: #ffff; position: sticky; left: 0; z-index: 1;"
              >
                <div class="box-columna-estatica-jug">
                  <div style="display:flex">
                    <div style="flex:1">
                      <div class="d-flex">
                        <img :src="item.foto_jug" alt="nd" width="77%" />
                      </div>
                    </div>
                        <!-- <span>{{item.id_jugador}}</span> -->

                    <!-- aqui emppieza los totales -->
                    <div
                      style="flex: 2; display:flex; flex-direction: column; height: 80px;"
                    >
                      <div class="row-principal-general">
                        <div class="row-box">
                          <template v-if="chekAmarilla">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/amarilla.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{
                                listFiltrado[index].totalAmarillasGeneral == 0
                                  ? ''
                                  : listFiltrado[index].totalAmarillasGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <template v-if="chekRoja">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/roja.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{
                                listFiltrado[index].totalRojasGeneral == 0
                                  ? ''
                                  : listFiltrado[index].totalRojasGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <template v-if="chekRojaDA">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/dosamar.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{
                                listFiltrado[index].totalRojasDAGeneral == '0'
                                  ? ''
                                  : listFiltrado[index].totalRojasDAGeneral
                              }}
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="row-principal-general">
                        <div class="row-box">
                          <template v-if="chekSanciones">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/sancionado.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{
                                listFiltrado[index].totalSancionadosGeneral == 0
                                  ? ''
                                  : listFiltrado[index].totalSancionadosGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <template v-if="chekGF">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/pelotac.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="text-box-total-jug">
                              {{
                                listFiltrado[index].golesMarcadosGeneral == 0
                                  ? ''
                                  : listFiltrado[index].golesMarcadosGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <!-- <template v-if="chekGC">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/gc.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{ listFiltrado[index].golesRecibidosGeneral }}
                            </div>
                          </template> -->
                        </div>
                      </div>
                      <div class="row-principal-general">
                        <div class="row-box">
                          <template v-if="chekDestacados">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/destacado_2.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">
                              {{
                                listFiltrado[index].totalMejoresGeneral == 0
                                  ? ''
                                  : listFiltrado[index].totalMejoresGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <template>
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/actuaciones.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="text-box-total-jug">
                              {{
                                listFiltrado[index].totalActuacionesGeneral == 0
                                  ? ''
                                  : listFiltrado[index].totalActuacionesGeneral
                              }}
                            </div>
                          </template>
                        </div>
                        <div class="row-box">
                          <template v-if="chekAux">
                            <div style=" flex:1;">
                              <img
                                class="img-box"
                                :src="
                                  require('@/assets/images/recursos/gc.png')
                                "
                                alt=""
                              />
                            </div>
                            <div class="   text-box-total-jug">sss</div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="color:white;  display:flex">
                    <!-- <div
                      style="flex:1; color: #8d053b; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPG">
                        Actuaciones:{{
                          listFiltrado[index].totalActuacionesGeneral
                        }}
                      </span>
                    </div> -->
                    <!-- <div
                      style="margin-left:7px;flex:1; color: #ffb8b8; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPP">
                        P:{{ listFiltrado[index].totalPerdidosGeneral }}
                      </span>
                    </div>
                    <div
                      style="margin-left:7px;flex:1; color: #fffea0; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPE">
                        E:{{ listFiltrado[index].totalEmpatadosGeneral }}
                      </span>
                    </div>
                    <div
                      style="margin-left:7px;flex:1; color: #f8b6ff; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPS">
                        S:{{
                          listFiltrado[index].totalSancionadosPartidoGeneral
                        }}
                      </span>
                    </div>
                    <div
                      style="margin-left:7px;flex:1; color: #74bef9; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPNP">
                        N:{{ listFiltrado[index].totalNoPresentadosGeneral }}
                      </span>
                    </div>
                    <div
                      style="margin-left:7px;flex:1; color: #e9e9ed; font-size: 12px; font-weight: bold;"
                    >
                      <span v-if="chekPJ">
                        F:{{ listFiltrado[index].totalPorJugarGeneral }}
                      </span>
                    </div> -->
                  </div>
                  <div class="nombre-equipo">
                    ({{ item.num_camiseta }}) {{ item.nombres }}
                    {{ item.apellidos }}
                  </div>
                </div>
              </td>

              <!-- Resto de las columnas con desplazamiento horizontal -->
              <td v-for="item2 in item.malla" :key="item2.id_partido">
                <div
                  class="contenedor-jug"
                  :style="
                    item2.partido.show
                      ? `background-color:${item2.color_participo}`
                      : ''
                  "
                >
                  <div
                    class="box-descansa"
                    v-if="item2.partido.final_usar == 'D' && item2.partido.show"
                  >
                    DESCANSA
                  </div>
                  <template
                    v-else-if="
                      item2.partido.rival != null && item2.partido.show
                    "
                  >
                    <div class="row-principal">
                      <div class="row-box">
                        <!-- <template v-if="chekAmarilla">
                          <div style=" flex:1;">
                            <img
                              :id="`pop_info_ama${item2.indiceNuevo}`"
                              class="img-box"
                              :src="
                                require('@/assets/images/recursos/amarilla.png')
                              "
                              alt=""
                            />
                            <b-popover
                              ref="popover"
                              :target="`pop_info_ama${item2.indiceNuevo}`"
                              triggers="hover"
                              :show.sync="popoverShowIA[item2.indiceNuevo]"
                              placement="auto"
                              container="my-container"
                            >
                              <template v-slot:title>
                                <div
                                  class="d-flex justify-content-between align-items-center"
                                >
                                  <span>Detalle de Amarillas</span>
                                </div>
                              </template>
                              <div
                                v-for="item in item2.partido.tarjetas"
                                :key="item.id"
                              >
                                <item-jugador-tarjeta
                                  v-if="item.t_a === '1'"
                                  :item="item"
                                ></item-jugador-tarjeta>
                              </div>
                            </b-popover>
                          </div>
                          <div class="text-box">
                            {{ item2.partido.totalAmarillas }}
                          </div>
                        </template> -->
                      </div>
                      <div class="row-box">
                        <template v-if="chekRoja">
                          <div style=" flex:1;">
                            <img
                              class="img-box"
                              :src="
                                item2.tr2a == '1'
                                  ? require('@/assets/images/recursos/dosamar.png')
                                  : item2.ta == '1'
                                  ? require('@/assets/images/recursos/amarilla.png')
                                  : item2.tr == '1'
                                  ? require('@/assets/images/recursos/roja.png')
                                  : item2.suspendido == 'si'
                                  ? require('@/assets/images/recursos/sancionado.png')
                                  : ''
                              "
                              alt=""
                            />
                          </div>
                          <div class="text-box">
                            <!-- {{ item2.partido.totalRojas }} -->
                            <!-- {{ item2.tr2a }}
                             {{ item2.ta }} -->
                            <template v-if="item2.ta == '1'">
                              {{ item2.orden }}</template
                            >
                          </div>
                        </template>
                      </div>
                      <div class="row-box">
                        <!-- <template v-if="chekRojaDA">
                          <div style=" flex:1;">
                            <img
                              :id="`pop_info_rojda${item2.indiceNuevo}`"
                              class="img-box"
                              :src="
                                require('@/assets/images/recursos/dosamar.png')
                              "
                              alt=""
                            />
                            <b-popover
                              ref="popover"
                              :target="`pop_info_rojda${item2.indiceNuevo}`"
                              triggers="hover"
                              :show.sync="popoverShowIARDA[item2.indiceNuevo]"
                              placement="auto"
                              container="my-container"
                            >
                              <template v-slot:title>
                                <div
                                  class="d-flex justify-content-between align-items-center"
                                >
                                  <span>Detalle Rojas x2A</span>
                                </div>
                              </template>
                              <div
                                v-for="item in item2.partido.tarjetas"
                                :key="item.id"
                              >
                                <item-jugador-tarjeta
                                  v-if="item.doble_a === '1'"
                                  :item="item"
                                ></item-jugador-tarjeta>
                              </div>
                            </b-popover>
                          </div>
                          <div class="text-box">
                            {{ item2.partido.totalRojasDA }}
                          </div>
                        </template> -->
                      </div>
                    </div>
                    <div class="row-principal">
                      <div class="row-box">
                        <template v-if="chekSanciones">
                          <div style=" flex:1;"></div>
                          <div class="text-box"></div>
                        </template>
                      </div>
                      <div class="row-box">
                        <template v-if="item2.anotaciones != 0">
                          <div style=" flex:1;">
                            <img
                              :id="`pop_info_goleadores${item2.indiceNuevo}`"
                              class="img-box"
                              :src="
                                require('@/assets/images/recursos/pelotac.png')
                              "
                              alt=""
                            />
                          </div>
                          <div class="text-box">
                            {{ item2.anotaciones }}
                          </div>
                        </template>
                      </div>
                      <div class="row-box">
                        <template> </template>
                      </div>
                    </div>
                    <div class="row-principal">
                      <div class="row-box">
                        <template v-if="chekDestacados"> </template>
                      </div>
                      <div class="row-box">
                        <template v-if="item2.destacado == 'si'">
                          <div style=" flex:1;">
                            <img
                              class="img-box"
                              :src="
                                require('@/assets/images/recursos/destacado_2.png')
                              "
                              alt=""
                            />
                          </div>
                          <div class="text-box"></div>
                        </template>
                      </div>
                      <div class="row-box">
                        <template v-if="chekAux">
                          <div style=" flex:1;">
                            <img
                              class="img-box"
                              :src="require('@/assets/images/recursos/gc.png')"
                              alt=""
                            />
                          </div>
                          <div class="text-box"></div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </b-overlay>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select'
import {
  BFormCheckbox,
  BCard,
  BCardBody,
  BOverlay,
  BTabs,
  BTab,
  VBPopover,
  BPopover,
  //   // BAvatar,
  //   // BBadge,
  BRow,
  BCol,
  //   //   xxxx,
  //   //   ssss,
} from 'bootstrap-vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  // watchEffect,
} from '@vue/composition-api'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  // xx
} from '../../utils/variables'
import itemJugadorTarjeta from './itemJugadorTarjeta.vue'

export default {
  components: {
    //   BTable,
    BFormCheckbox,
    BCard,
    BCardBody,
    vSelect,
    BOverlay,
    BTabs,
    BTab,
    BPopover,
    itemJugadorTarjeta,
    //   // BAvatar,
    //   // BBadge,
    BRow,
    BCol,
  },
  directives: {
    'b-popover': VBPopover,
  },
  props: {
    listCategorias: Array,
    listCampeonatos: Array,
    listEquipos: Array,
    seleccionado: Object,
    // showLoading: Boolean,
  },
  setup(props, { emit }) {
    const { getApi } = apiCall()
    const stickyHeader = ref(true)
    const noCollapse = ref(false)
    const lisEstadisticas = ref([])
    const popoverShowIA = ref([])
    const popoverShowIAR = ref([])
    const popoverShowIARDA = ref([])
    const popoverShowSanciones = ref([])
    const popoverShowGoleadores = ref([])
    const popoverShowDestacados = ref([])
    const tabModel = ref(0)
    const mallaAux = computed(() => lisEstadisticas.value[0] || [])
    const estilos = ref([
      'background:gray',
      'background:#00bcd4',
      'background:#6ba27b',
      'background:#a5850c',
      'background:#0c3fa5',
      'background:#8c33d5',
    ])
    const checkTipos = ref([{ model: 'ta', label: 'T.Amarilla' }])
    const chekTodos = ref(true)
    const chekTodosEstados = ref(true)
    const chekAmarilla = ref(true)
    const chekRoja = ref(true)
    const chekRojaDA = ref(true)
    const chekSanciones = ref(true)
    const chekDestacados = ref(true)
    const chekAux = ref(false)
    const chekGF = ref(true)
    const chekPG = ref(true)
    const chekPP = ref(true)
    const chekPE = ref(true)
    const chekPS = ref(true)
    const chekPJ = ref(true)
    const chekPNP = ref(true)
    const chekPD = ref(true)
    const showLoading = ref(false)
    const mostra = ref(false)
    const categoriaSeleccionada = ref({
      label: 'Seleccione categoría',
      goles_no_presentacion: '0',
      value: null,
    })
    const equipoSeleccionada = ref(null)
    const campeonatoSeleccionado = computed({
      get: () => props.seleccionado,
      set: value => {
        // props.isManualProp = value
        lisEstadisticas.value = []
        categoriaSeleccionada.value = null
        emit('change', value)
      },
    })
    const estadosFiltro = ref(['G', 'P', 'E', 'PJ', 'PS', 'NP', 'D'])

    const listFiltrado = computed(
      () => {
        let datos = []
        lisEstadisticas.value.forEach(equipo => {
          let totalAmarillas = 0
          let totalRojas = 0
          let totalRojasDA = 0
          let totalSancionados = 0
          let goles_marcados = 0
          let goles_recibidos = 0
          let totalMejores = 0
          let totalActuaciones = 0
          let totalGanados = 0
          let totalPerdidos = 0
          let totalEmpatados = 0
          let totalNoPresentados = 0
          let totalSancionadosPartido = 0
          let totalPorJugar = 0
          let objeto = {}
          equipo.malla.forEach(partido => {
            if (partido.ta !== 0 && partido.ta !== undefined) {
              totalAmarillas += parseInt(partido.ta)
            }
            if (partido.tr !== 0 && partido.tr !== undefined) {
              totalRojas += parseInt(partido.tr)
            }
            if (partido.tr2a !== 0 && partido.tr2a !== undefined) {
              totalRojasDA += parseInt(partido.tr2a)
            }
            if (
              partido.anotaciones !== 0 &&
              partido.anotaciones !== undefined
            ) {
              goles_marcados += parseInt(partido.anotaciones)
            }
            if (
              partido.suspendido !== 'no' &&
              partido.suspendido !== undefined
            ) {
              totalSancionados++
            }
            if (partido.destacado !== 'no' && partido.destacado !== undefined) {
              totalMejores++
            }
            if (partido.participo !== 'n' && partido.participo !== undefined) {
              totalActuaciones++
            }
            if (partido.partido.final_usar === 'G') {
              totalGanados++
            }
            if (partido.partido.final_usar === 'P') {
              totalPerdidos++
            }
            if (partido.partido.final_usar === 'E') {
              totalEmpatados++
            }
            if (partido.partido.final_usar === 'NP') {
              totalNoPresentados++
            }
            if (partido.partido.final_usar === 'PS') {
              totalSancionadosPartido++
            }
            if (partido.partido.final_usar === 'PJ') {
              totalPorJugar++
            }
          })
          objeto = {
            totalAmarillasGeneral: totalAmarillas,
            totalRojasGeneral: totalRojas,
            totalRojasDAGeneral: totalRojasDA,
            totalSancionadosGeneral: totalSancionados,
            golesMarcadosGeneral: goles_marcados,
            golesRecibidosGeneral: goles_recibidos,
            totalMejoresGeneral: totalMejores,
            totalGanadosGeneral: totalGanados,
            totalPerdidosGeneral: totalPerdidos,
            totalEmpatadosGeneral: totalEmpatados,
            totalNoPresentadosGeneral: totalNoPresentados,
            totalSancionadosPartidoGeneral: totalSancionadosPartido,
            totalPorJugarGeneral: totalPorJugar,
            totalActuacionesGeneral: totalActuaciones,
          }
          datos.push(objeto)
          // console.log(datos)
        })
        return datos
      }

      // store.getters['someVariables/getListEstadisticas']
      // lisEstadisticas.value.filter(equipo =>
      //   equipo.malla.some(item => item.partido.final_usar=='G')
      //   // console.log(partido)
      // )
    )

    async function getEstadisticas(idCategoria, idCampeonato) {
      showLoading.value = true
      lisEstadisticas.value = []
      const path = `ApiFixture/getEstadisticasEquiposWeb/${idCategoria}/${idCampeonato}`
      const data = await getApi(URL, path)
      lisEstadisticas.value = data
      showLoading.value = false
    }
    function changeCategoria() {
      // console.log(item)
      // console.log(campeonatoSeleccionado.value)
      // getEstadisticas(
      //   categoriaSeleccionada.value.id_categoria,
      //   campeonatoSeleccionado.value.value
      // )
      getEstadisticas(
        equipoSeleccionada.value.value,
        campeonatoSeleccionado.value.value
      )
    }

    function filtrarTipoPartidos() {
      const listAux = [...lisEstadisticas.value] // o lisEstadisticas.value.slice()
      // const query=hacerStringEstados(cotejo.partido.final_usar)
      // console.log(estadosFiltro.value)
      listAux.forEach(equipo => {
        equipo.malla.forEach(cotejo => {
          // console.log(cotejo.partido)
          if (estadosFiltro.value.includes(cotejo.partido.final_usar)) {
            cotejo.partido.show = true
          } else {
            cotejo.partido.show = false
          }
        })
      })
      lisEstadisticas.value = listAux
      // store.commit('someVariables/UPDATE_LIST_ESTADISTICAS', listAux)
    }
    function limpiarLlenarCheks(valor) {
      chekAmarilla.value = valor
      chekRoja.value = valor
      chekRojaDA.value = valor
      chekSanciones.value = valor
      chekGF.value = valor
      chekDestacados.value = valor
    }
    function limpiarLlenarCheksEstados(valor) {
      chekPG.value = valor
      chekPP.value = valor
      chekPE.value = valor
      chekPNP.value = valor
      chekPS.value = valor
      chekPJ.value = valor
      chekPD.value = valor
    }

    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )

    watch(cambioTorneo, data => {
      // console.log('watch config')
      categoriaSeleccionada.value = {
        label: 'Seleccione categoría',
        goles_no_presentacion: '0',
      }
      // selectEtapas.value = ''
      // listEtapas.value = []
      // listGrupos.value = []
      // listPartidosFixture.value = []
    })

    watch(chekTodos, data => {
      if (data) {
        limpiarLlenarCheks(true)
      } else {
        limpiarLlenarCheks(false)
      }
    })
    watch(chekTodosEstados, data => {
      if (data) {
        limpiarLlenarCheksEstados(true)
      } else {
        limpiarLlenarCheksEstados(false)
      }
    })
    function hacerStringEstados(variable) {
      const query = ''
      estadosFiltro.value.forEach(element => {
        query += `${variable}==${element} || `
      })
      return query
    }
    watch(chekPG, data => {
      const sigla = 'G'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPP, data => {
      const sigla = 'P'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPE, data => {
      const sigla = 'E'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPS, data => {
      const sigla = 'PS'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPJ, data => {
      const sigla = 'PJ'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPNP, data => {
      const sigla = 'NP'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })
    watch(chekPD, data => {
      const sigla = 'D'
      if (data) {
        estadosFiltro.value.push(sigla)
      } else {
        const index = estadosFiltro.value.indexOf(sigla)
        if (index !== -1) {
          estadosFiltro.value.splice(index, 1)
        }
      }
      filtrarTipoPartidos()
    })

    // watch(chekPG, data => {
    //   if (data) {
    //     filtrarTipoPartidos('G')
    //     console.log(listFiltrado.value)
    //   } else {
    //     filtrarTipoPartidos('')
    //   }
    // })
    return {
      stickyHeader,
      noCollapse,
      getEstadisticas,
      lisEstadisticas,
      mallaAux,
      estilos,
      checkTipos,
      chekAmarilla,
      chekRoja,
      chekRojaDA,
      chekSanciones,
      chekGF,
      chekTodos,
      chekTodosEstados,
      chekPG,
      chekPP,
      chekPE,
      chekPS,
      chekPJ,
      chekPNP,
      chekPD,
      chekAux,
      chekDestacados,
      listFiltrado,
      categoriaSeleccionada,
      changeCategoria,
      showLoading,
      tabModel,
      popoverShowIA,
      popoverShowIAR,
      popoverShowIARDA,
      popoverShowSanciones,
      popoverShowGoleadores,
      popoverShowDestacados,
      campeonatoSeleccionado,
      mostra,
      equipoSeleccionada,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.fila {
  height: 65px !important;
  background-color: #a32d2d;
  position: sticky;
  top: 0;
}
.contenedor-jug {
  width: 160px;
  border-radius: 5px;
  padding: 10px 10px 0px 10px;
  /* background-color: rgb(243, 244, 240); */
  height: 105px;
  margin: 0px;
  display: flex;
  flex-direction: column;
}
.row-principal {
  flex: 1;
  display: flex;
}
.row-principal-general {
  flex: 1;
  display: flex;
  margin-bottom: 5px;
}
.row-box {
  flex: 1;
  display: flex;
}
.text-box {
  flex: 1;
  text-align: left;
  font-size: 15px;
  font-weight: 600;
  color: black;
}
.text-box-total-jug {
  flex: 1;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: rgb(46, 45, 45);
  display: flex;
  align-items: center;
}
.img-box {
  width: 65%;
}
.box-descansa {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: center;
}
.nombre-equipo {
  border-radius: 3px 3px 0px 0px;
  display: flex;
  justify-content: start;
  align-items: start;
  height: 16px;
  background: white;
  text-align: center;
  color: black;
  text-transform: uppercase;
  font-size: 10px;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  padding-left: 10px;
  text-overflow: ellipsis; /* Mostrar puntos suspensivos (...) */
}
.box-columna-estatica-jug {
  width: 255px;
  height: 105px;
  padding: 10px;
  font-size: 11px;
}
</style>
